import { getCookie } from './cookieService';
import { baseRoute } from '../constants/routes';

/**
 *
 */
class httpService {
    request = ( route, method, body, formData = false, resolve ) => {
        window.fetchError = null;
        let requestHeaders = ( getCookie( 'token' ) === false ) ? {} : {
            'Authorization': `Bearer ${ getCookie( 'token' ) }`
        };

        if ( !formData ) {
            requestHeaders = { ...requestHeaders, 'Content-Type': 'application/json' };
        }

        return fetch( route, {
            headers: {
                ...requestHeaders
            },
            method,
            body: formData ? body : body && JSON.stringify( body )
        } )
            .then( ( res ) => {
                    const rsdJson = res.json();
                    if ( res.status === 200 || res.status === 201 ) {

                        if ( typeof resolve === 'function' ) {
                            resolve( rsdJson );
                        }
                        return rsdJson;
                    } else if ( res.status === 400 || res.status === 401 ) {
                        return rsdJson;
                    } else {
                        return this.throwStatusError( res.status );
                    }
                }
            )
            .then( data => data )
            .catch( ( error ) => {
                this.throwFetchError( error );
            } );
    };

    throwStatusError = ( statusCode ) => {
        throw new Error( statusCode );
    };

    throwFetchError = error => {
        console.warn( 'Do not worry. This error will not break the frontend, it is just a log.' );
        console.warn( error );
        window.fetchError = { info: error, status: true };
        return false;
    };

    trackWindowClose = ( gameID, isPreview ) => {
        const CLEAR_STATISTIC_PREVIEW = baseRoute + '/delete-preview';
        const EXIT_GAME_ROUTE = baseRoute + '/exit-game';

        const data = new FormData();
        data.append( 'uuid_front', getCookie( 'uuid' ) );
        data.append( 'game_id', gameID );

        navigator.sendBeacon( EXIT_GAME_ROUTE, data );
        isPreview && navigator.sendBeacon( CLEAR_STATISTIC_PREVIEW, data );
    }
}

export default new httpService();
